import { Loader } from '@myosh/odin-components';

interface LoginLoaderProps {
  title?: string;
}

const LoginLoader = ({ title }: LoginLoaderProps) => {
  const loaderStyles = 'mx-auto flex h-screen w-full flex-col items-center justify-center';
  return (
    <div className={loaderStyles}>
      <Loader title={title} />
    </div>
  );
};

export default LoginLoader;
